import { useState, useEffect, useRef } from "react";
import { verifyTotp, clearPending2faToken } from "./authService";
import useBootstrapCSS from "../../hooks/useBootstrapCSS";
import codLogo from "./CoD-Logo.png";
import "./login.css";

const EnterTotp = () => {
    useBootstrapCSS();
    const [code, setCode] = useState("");
    const [message, setMessage] = useState({ text: "", type: "" });
    const [isVerifying, setIsVerifying] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    const handleVerify = async () => {
        const trimmed = code.trim();
        if (!trimmed) {
            setMessage({ text: "Please enter the 6-digit code", type: "fail" });
            return;
        }
        if (trimmed.length !== 6) {
            setMessage({ text: "Code must be 6 digits", type: "fail" });
            return;
        }

        setIsVerifying(true);
        setMessage({ text: "", type: "" });

        try {
            const result = await verifyTotp(trimmed);
            if (result.success) {
                setMessage({ text: "Verified! Redirecting...", type: "success" });
                clearPending2faToken();
                localStorage.setItem("token", result.token);
                if (result.refreshToken) localStorage.setItem("refreshToken", result.refreshToken);
                setTimeout(() => { window.location.href = "/dashboard"; }, 1000);
            } else {
                setMessage({ text: result.error || "Verification failed", type: "fail" });
                setIsVerifying(false);
            }
        } catch (error) {
            setMessage({ text: error.message || "Verification failed", type: "fail" });
            setIsVerifying(false);
            setCode("");
            inputRef.current?.focus();
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleVerify();
        }
    };

    const getMessageClass = () => {
        if (message.type === "success") return "successmessage";
        if (message.type === "loading") return "loadingmessage";
        return "failmessage";
    };

    return (
        <section className="login-page">
            <div className="container-fluid">
                <div className="row align-items-center h-100">
                    <div className="col-md-6 col-sm-12 px-5 left-graphic">
                        <img src={codLogo} className="img-fluid" alt="CoD Logo" />
                    </div>

                    <div className="col-md-6 col-sm-12 px-5 form-outer h-100 align-items-center d-flex flex-column justify-content-center">
                        <form className="initial-form" onSubmit={(e) => e.preventDefault()}>
                            <h3 className="h3 mb-3">Two-Factor Authentication</h3>
                            <p className="text-muted mb-20">
                                Open <strong>Microsoft Authenticator</strong> and enter the 6-digit code for <em>AML Deal Check</em>.
                            </p>

                            {message.text && (
                                <div className={`p-2 mb-20 ${getMessageClass()}`}>
                                    {message.text}
                                </div>
                            )}

                            <div className="form-group mb-20">
                                <label htmlFor="totpInput">Authenticator Code</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="totpInput"
                                    placeholder="000000"
                                    value={code}
                                    onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
                                    onKeyDown={handleKeyDown}
                                    ref={inputRef}
                                    maxLength={6}
                                    inputMode="numeric"
                                    autoComplete="one-time-code"
                                    required
                                />
                            </div>

                            <button
                                type="button"
                                className="btn btn-primary mb-20 w-100"
                                onClick={handleVerify}
                                disabled={isVerifying}
                            >
                                {isVerifying ? "Verifying..." : "Verify"}
                            </button>
                        </form>
                        <div className="form-footer">
                            <p>Copyright &copy; {new Date().getFullYear()} Compliance on Demand. All Rights Are Reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EnterTotp;
